import { cn } from "@/lib/cn";
import { useBranding } from "@/lib/branding";

interface LogoProps {
  className?: string;
  variant?: "default" | "white";
}

const AON_DEFAULT_LOGO = "/img/logo.svg";

/**
 * Logo de la plateforme.
 *
 * Par défaut le logo officiel Aon (`/public/img/logo.svg`), mais surchargé par
 * le branding du tenant courant (`tokens.logoUrl` / `tokens.logoDarkUrl`) quand
 * un cobranding est configuré.
 *
 * Variante `white` (fonds sombres) : utilise `logoDarkUrl` si fourni, sinon le
 * logo clair. Le filtre d'inversion n'est appliqué QUE sur le SVG Aon par
 * défaut (les logos custom sont affichés tels quels).
 */
export function Logo({ className, variant = "default" }: LogoProps) {
  const { tokens } = useBranding();

  const customLight = tokens.logoUrl?.trim() || null;
  const customDark = tokens.logoDarkUrl?.trim() || null;

  let src = AON_DEFAULT_LOGO;
  if (variant === "white") {
    src = customDark ?? customLight ?? AON_DEFAULT_LOGO;
  } else {
    src = customLight ?? AON_DEFAULT_LOGO;
  }

  const isDefaultSvg = src === AON_DEFAULT_LOGO;
  const productName = tokens.productName || "Aon";

  return (
    <img
      src={src}
      alt={productName}
      className={cn(
        "h-14 w-auto select-none",
        variant === "white" && isDefaultSvg && "brightness-0 invert",
        className,
      )}
      draggable={false}
    />
  );
}
